import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  getBenchMarkList,
  getUnderlyingBenchmarkDetails,
  getUnderlyingBenchmarkList,
  saveBenchmark,
} from '@services/benchmark.service'

import {
  IBenchMarkDTO,
  ISaveBenchmarkResponse,
  ISaveBenchmarksPayload,
  IUnderlyingBenchmarkDetailsDTO,
  IUnderlyingBenchmarksDTO,
} from '@interfaces/interfaces'

interface BenchMarkState {
  benchmarks: IBenchMarkDTO[]
  underlyingBenchmarks: IUnderlyingBenchmarksDTO[]
  underlyingBenchmarkDetails: IUnderlyingBenchmarkDetailsDTO
  saveBenchmarkResponseData: ISaveBenchmarkResponse
}

const initialState: BenchMarkState = {
  benchmarks: [],
  underlyingBenchmarks: [],
  underlyingBenchmarkDetails: {} as IUnderlyingBenchmarkDetailsDTO,
  saveBenchmarkResponseData: {} as ISaveBenchmarkResponse,
}

export const benchMarkSlice = createSlice({
  name: 'benchmark',
  initialState,
  reducers: {
    setBenchMark: (state, action: PayloadAction<IBenchMarkDTO[]>) => {
      state.benchmarks = action.payload
    },
    setUnderlyingBenchmark: (
      state,
      action: PayloadAction<IUnderlyingBenchmarksDTO[]>,
    ) => {
      state.underlyingBenchmarks = action.payload
    },
    setUnderlyingBenchmarkDetails: (
      state,
      action: PayloadAction<IUnderlyingBenchmarkDetailsDTO>,
    ) => {
      state.underlyingBenchmarkDetails = action.payload
    },
    setSaveBenchmark: (
      state,
      action: PayloadAction<ISaveBenchmarkResponse>,
    ) => {
      state.saveBenchmarkResponseData = action.payload
    },
    clear: (state) => {
      state.benchmarks = []
      state.underlyingBenchmarks = []
      state.underlyingBenchmarkDetails = {} as IUnderlyingBenchmarkDetailsDTO
      state.saveBenchmarkResponseData = {} as ISaveBenchmarkResponse
    },
  },
})

export const {
  setBenchMark,
  clear,
  setUnderlyingBenchmark,
  setUnderlyingBenchmarkDetails,
  setSaveBenchmark,
} = benchMarkSlice.actions

export default benchMarkSlice.reducer

export const fetchBenchMarksAsync = () => (dispatch: Function) => {
  getBenchMarkList()
    .then((response) => {
      console.log('response  ', JSON.stringify(response))
      return dispatch(setBenchMark(response))
    })
    .catch((error) => {
      console.error('fetch structure', error)
    })
}

export const fetchUnderlyingBenchmarksAsync = () => (dispatch: Function) => {
  getUnderlyingBenchmarkList()
    .then((response) => {
      return dispatch(setUnderlyingBenchmark(response))
    })
    .catch((error) => {
      console.error('fetch underlying benchmarks', error)
    })
}

export const fetchUnderlyingBenchmarkDetailsAsync =
  (id: number) => (dispatch: Function) => {
    getUnderlyingBenchmarkDetails(id)
      .then((response) => {
        return dispatch(setUnderlyingBenchmarkDetails(response))
      })
      .catch((error) => {
        console.error('fetch underlying benchmarks details', error)
      })
  }

export const saveBenchmarkAsync =
  (payload: ISaveBenchmarksPayload) => (dispatch: Function) => {
    saveBenchmark(payload)
      .then((response: ISaveBenchmarkResponse) => {
        return dispatch(setSaveBenchmark(response))
      })
      .catch((error) => {
        console.error('fetch save benchmarks data', error)
      })
  }
